import { BASE_PATH, BASE_PATH_EXTENSION } from "../../utils/constants";
import { getToken } from "../Auth/token";
import axios from "axios";

const urlBase = `${BASE_PATH}${BASE_PATH_EXTENSION}/admin/geografia`;

function authConfig() {
    return { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
}

// ----------- REGION CRUD ------------
export async function listRegionApi() {
    return axios.get(`${urlBase}/region/search`, authConfig());
}
export async function getRegionApi(id) {
    return axios.get(`${urlBase}/region/datil/${id}`, authConfig());
}
export async function createRegionApi(data) {
    return axios.post(`${urlBase}/region/create`, data, authConfig());
}
export async function updateRegionApi(id, data) {
    return axios.post(`${urlBase}/region/update/${id}`, data, authConfig());
}
export async function deleteRegionApi(id) {
    return axios.delete(`${urlBase}/region/remove/${id}`, authConfig());
}

// ----------- PROVINCE CRUD ------------
export async function listProvinceApi() {
    return axios.get(`${urlBase}/province/search`, authConfig());
}
export async function getProvinceApi(id) {
    return axios.get(`${urlBase}/province/datil/${id}`, authConfig());
}
export async function createProvinceApi(data) {
    return axios.post(`${urlBase}/province/create`, data, authConfig());
}
export async function updateProvinceApi(id, data) {
    return axios.post(`${urlBase}/province/update/${id}`, data, authConfig());
}
export async function deleteProvinceApi(id) {
    return axios.delete(`${urlBase}/province/remove/${id}`, authConfig());
}

// ----------- MUNICIPALITY CRUD ------------
export async function listMunicipalityApi() {
    return axios.get(`${urlBase}/municipality/search`, authConfig());
}
export async function getMunicipalityApi(id) {
    return axios.get(`${urlBase}/municipality/datil/${id}`, authConfig());
}
export async function createMunicipalityApi(data) {
    return axios.post(`${urlBase}/municipality/create`, data, authConfig());
}
export async function updateMunicipalityApi(id, data) {
    return axios.post(`${urlBase}/municipality/update/${id}`, data, authConfig());
}
export async function deleteMunicipalityApi(id) {
    return axios.delete(`${urlBase}/municipality/remove/${id}`, authConfig());
}

// ----------- COMARCA CRUD ------------
export async function listComarcaApi() {
    return axios.get(`${urlBase}/comarca/search`, authConfig());
}
export async function getComarcaApi(id) {
    return axios.get(`${urlBase}/comarca/datil/${id}`, authConfig());
}
export async function createComarcaApi(data) {
    return axios.post(`${urlBase}/comarca/create`, data, authConfig());
}
export async function updateComarcaApi(id, data) {
    return axios.post(`${urlBase}/comarca/update/${id}`, data, authConfig());
}
export async function deleteComarcaApi(id) {
    return axios.delete(`${urlBase}/comarca/remove/${id}`, authConfig());
}

// ----------- COUNTRY CRUD ------------
export async function listCountryApi() {
    return axios.get(`${urlBase}/country/search`, authConfig());
}
export async function getCountryApi(id) {
    return axios.get(`${urlBase}/country/datil/${id}`, authConfig());
}
export async function createCountryApi(data) {
    return axios.post(`${urlBase}/country/create`, data, authConfig());
}
export async function updateCountryApi(id, data) {
    return axios.post(`${urlBase}/country/update/${id}`, data, authConfig());
}
export async function deleteCountryApi(id) {
    return axios.delete(`${urlBase}/country/remove/${id}`, authConfig());
}
